{
  "page": {
    "title": "Настройка раздела",
    "loading": "Загрузка…",
    "loadError": "Не удалось загрузить данные раздела",
    "folderError": "Не удалось загрузить документ папки",
    "notFound": "Раздел не найден или удалён",
    "retry": "Повторить"
  },
  "mode": {
    "label": "Режим раздела",
    "drawing": "Чертёж",
    "3d": "3D"
  },
  "actions": {
    "preview": "Просмотр",
    "save": "Сохранить",
    "saveHint": "Сохранить (Ctrl+S)",
    "cancel": "Отмена",
    "delete": "Удалить"
  },
  "save": {
    "success": "Сохранено",
    "successHint": "Изменения видны всем пользователям",
    "error": "Не удалось сохранить",
    "errorHint": "Проверьте подключение и повторите попытку"
  },
  "conflict": {
    "title": "Страницу изменил другой пользователь",
    "text": "Сохранена новая версия документа. Загрузите её или перезапишите своими изменениями.",
    "textBy": "{{name}} сохранил(а) новую версию в {{time}}. Загрузите её или перезапишите своими изменениями.",
    "reload": "Загрузить заново",
    "overwrite": "Перезаписать",
    "cancel": "Отмена",
    "reloaded": "Загружена последняя версия документа"
  },
  "guard": {
    "title": "Есть несохранённые изменения. Выйти?",
    "text": "Если выйти без сохранения, изменения будут потеряны.",
    "stay": "Отмена",
    "discard": "Выйти без сохранения",
    "save": "Сохранить"
  },
  "panel": {
    "close": "Закрыть",
    "drag": "Перетащить"
  },
  "slider": {
    "decrease": "уменьшить",
    "increase": "увеличить"
  },
  "folders": {
    "label": "Папки",
    "add": "Добавить",
    "createTitle": "Новая модификация",
    "renameTitle": "Редактировать модификацию",
    "subtitle": "Новая модификация чертежа",
    "nameLabel": "Название модификации",
    "namePlaceholder": "883.60",
    "continue": "Продолжить",
    "created": "Модификация «{{name}}» добавлена",
    "renamed": "Модификация переименована",
    "deleted": "«{{name}}» удалена",
    "deleteTitle": "Удалить модификацию",
    "deleteText": "«{{name}}» вместе с чертежом и показателями будет удалена.",
    "deleteError": "Не удалось удалить модификацию",
    "defaultNoDelete": "Основную папку удалить нельзя",
    "limit": "Достигнут лимит папок ({{max}})",
    "unsaved": "Есть несохранённые изменения",
    "pinCount_one": "{{count}} показатель",
    "pinCount_few": "{{count}} показателя",
    "pinCount_many": "{{count}} показателей",
    "pinCount_other": "{{count}} показателя",
    "menu": {
      "rename": "Редактировать",
      "replace": "Заменить",
      "delete": "Удалить"
    },
    "errors": {
      "required": "Введите название модификации",
      "tooLong": "Не более {{max}} символов",
      "taken": "Папка с таким названием уже есть",
      "generic": "Не удалось сохранить"
    }
  },
  "rail": {
    "label": "Слои",
    "drawing": "Чертёж",
    "deviceInfo": "Об устройстве",
    "data": "База данных",
    "table": "Таблица",
    "state": {
      "uploaded": "загружен",
      "notUploaded": "не загружен",
      "enabled": "включено",
      "disabled": "выключено",
      "configured": "настроена",
      "notConfigured": "не настроена"
    }
  },
  "canvas": {
    "label": "Область чертежа",
    "drawing": "Чертёж и показатели",
    "roleDescription": "редактор чертежа",
    "emptyTitle": "Чертёж не загружен",
    "emptyText": "Для начала загрузите файл чертежа в эту папку.",
    "upload": "Загрузить чертёж",
    "placingHint": "Выберите место на чертеже (отмена: Esc)",
    "zoomIn": "Увеличить",
    "zoomOut": "Уменьшить",
    "fit": "Вписать (100%)",
    "dropHere": "Перетащите файл чертежа сюда"
  },
  "drawing": {
    "emptyTitle": "Чертёж не загружен",
    "emptyText": "Чертежа пока нет. Нажмите «Загрузить чертёж» и выберите файл SVG, PNG или DWG.",
    "opacity": "Прозрачность",
    "scale": "Масштаб",
    "replace": "Заменить чертёж",
    "delete": "Удалить чертёж",
    "deleteTitle": "Удалить чертёж",
    "deleteText": "Чертёж будет удалён из папки. Показатели останутся и появятся после загрузки нового чертежа.",
    "deletePinsToo_one": "Удалить и показатель ({{count}})",
    "deletePinsToo_few": "Удалить и показатели ({{count}})",
    "deletePinsToo_many": "Удалить и показатели ({{count}})",
    "deletePinsToo_other": "Удалить и показатели ({{count}})",
    "uploading": "Загрузка… {{progress}}%",
    "uploaded": "Чертёж загружен",
    "replaced": "Чертёж заменён",
    "saveHint": "Не забудьте сохранить изменения",
    "uploadError": "Не удалось прочитать файл",
    "typeError": "Этот тип файла не поддерживается",
    "sizeError": "Файл слишком большой",
    "formats": "SVG, PNG, JPG или WEBP · до 50 МБ",
    "dwgTitle": "Конвертация DWG пока недоступна",
    "dwgText": "Экспортируйте чертёж в SVG или PNG и загрузите его.",
    "aspectChanged": "Пропорции чертежа изменились — проверьте расположение показателей"
  },
  "pins": {
    "title": "Показатели",
    "add": "Добавить показатель",
    "cancelPlacing": "Отменить выбор места",
    "emptyTitle": "Показателей нет",
    "emptyText": "Показателей пока нет. Нажмите «Добавить показатель» и выберите место на чертеже.",
    "needDrawing": "Сначала загрузите чертёж",
    "needDrawingHint": "Показатели размещаются на чертеже",
    "limit": "Достигнут лимит показателей ({{max}})",
    "untitled": "Новый показатель",
    "noDevice": "Устройство не выбрано",
    "rows_one": "{{count}} показатель",
    "rows_few": "{{count}} показателя",
    "rows_many": "{{count}} показателей",
    "rows_other": "{{count}} показателя",
    "show": "{{name}} — показать",
    "hide": "{{name}} — скрыть",
    "hiddenHint": "Скрыт на странице просмотра",
    "visibleHint": "Виден на странице просмотра",
    "settings": "Настройки {{name}}",
    "delete": "{{name}} — удалить"
  },
  "pin": {
    "back": "Назад",
    "title": "Настройки устройства",
    "device": "УСТРОЙСТВО",
    "devicePlaceholder": "Выберите устройство",
    "dynamic": "Динамически — от устройства: {{value}}",
    "rows": "СТРОКИ (ИМЯ = ЗНАЧЕНИЕ)",
    "rowName": "Название строки {{index}}",
    "rowNamePlaceholder": "Имя ({{suffix}})",
    "rowNamePlain": "Имя",
    "rowSource": "Источник значения строки {{index}}",
    "rowValue": "Значение строки {{index}}",
    "rowValuePlaceholder": "Значение (0.45 мм)",
    "removeRow": "Удалить строку {{index}}",
    "manual": "Ввести вручную...",
    "addRow": "Добавить строку",
    "rowsLimit": "Не более {{max}} строк",
    "rowsHint": "Выберите значение из показателя устройства или введите вручную.",
    "addSensorRow": "Устройство",
    "labelPlacement": "РАСПОЛОЖЕНИЕ ПОДПИСИ",
    "side": {
      "top": "Сверху",
      "right": "Справа",
      "bottom": "Снизу",
      "left": "Слева"
    },
    "distance": "РАССТОЯНИЕ ОТ ТОЧКИ",
    "offsetVertical": "СМЕЩЕНИЕ ВВЕРХ / ВНИЗ",
    "offsetHorizontal": "СМЕЩЕНИЕ ВЛЕВО / ВПРАВО",
    "hint": "Точка остаётся на месте — смещается только карточка подписи. Размер точки не меняется.",
    "delete": "Удалить устройство",
    "deleteTitle": "Удалить устройство",
    "deleteText": "«{{code}}» будет удалено с чертежа и из 3D-модели.",
    "deleted": "«{{code}}» удалено",
    "undoHint": "Отменить: Ctrl+Z"
  },
  "picker": {
    "placeholder": "Выберите",
    "search": "Поиск устройства или показателя",
    "loading": "Загрузка устройств…",
    "empty": "Ничего не найдено",
    "missing": "Устройство не найдено",
    "otherCategory": "Прочие устройства"
  },
  "layers": {
    "showInViewer": "Показывать на странице просмотра"
  },
  "deviceInfo": {
    "title": "Информация об устройстве",
    "enabledHint": "Включено — появится кнопка «Информация об устройстве»",
    "disabledHint": "Выключено — на странице просмотра не отображается",
    "name": "Название",
    "namePlaceholder": "Введите название устройства",
    "media": "Фото и видео",
    "mediaTitle": "Загрузите фото или видео",
    "mediaHint": "JPG, PNG, MP4 · до 50 МБ",
    "addMedia": "Добавить фото или видео",
    "removeMedia": "{{name}} — удалить",
    "cover": "обложка",
    "mediaLimit": "Не более {{max}} фото или видео",
    "typeError": "Только изображения JPG, PNG, WEBP или видео MP4, WEBM",
    "sizeError": "Размер файла не более 50 МБ",
    "uploadError": "Не удалось загрузить файл",
    "collage": "Стиль коллажа",
    "grid": "Сетка",
    "mosaic": "Мозаика",
    "carousel": "Лента",
    "collagePreview": "Вид коллажа",
    "previous": "Предыдущее",
    "next": "Следующее",
    "description": "Описание",
    "editorName": "Профессиональный редактор",
    "descriptionPlaceholder": "Подробно опишите устройство…",
    "textEmpty": "Текст пуст",
    "textBlocks_one": "Текст · {{count}} блок",
    "textBlocks_few": "Текст · {{count}} блока",
    "textBlocks_many": "Текст · {{count}} блоков",
    "textBlocks_other": "Текст · {{count}} блока",
    "limitReached": "Текст не длиннее {{max}} символов",
    "linkInvalid": "Неверная ссылка (http, https, mailto или tel)",
    "pdf": "Скачивание PDF",
    "pdfOff": "Выключено — при включении появится кнопка PDF",
    "pdfOn": "Включено — пользователь скачивает PDF"
  },
  "rte": {
    "toolbar": "Форматирование текста",
    "blockType": "Тип блока",
    "size": "Размер текста",
    "paragraph": "Абзац",
    "heading1": "Заголовок 1",
    "heading2": "Заголовок 2",
    "quote": "Цитата",
    "codeBlock": "Блок кода",
    "undo": "Отменить",
    "redo": "Повторить",
    "bold": "Жирный",
    "italic": "Курсив",
    "underline": "Подчёркнутый",
    "color": "Цвет текста",
    "bullets": "Маркированный список",
    "numbers": "Нумерованный список",
    "checklist": "Список задач",
    "link": "Ссылка",
    "linkUrl": "Адрес ссылки",
    "applyLink": "Добавить",
    "unlink": "Убрать",
    "alignLeft": "По левому краю",
    "alignCenter": "По центру",
    "alignRight": "По правому краю",
    "alignJustify": "По ширине",
    "table": "Вставить таблицу",
    "image": "Вставить изображение",
    "code": "Код",
    "clear": "Очистить формат"
  },
  "data": {
    "enabledHint": "Включено — появится панель «График устройства»",
    "disabledHint": "Выключено — на странице просмотра не отображается",
    "name": "Заголовок",
    "namePlaceholder": "График устройства",
    "series": "Устройства",
    "addSeries": "Добавить устройство",
    "seriesLimit": "Не более {{max}} устройств",
    "removeSeries": "{{name}} — удалить",
    "color": "Цвет линии",
    "axis": "Ось",
    "left": "Лев.",
    "right": "Прав.",
    "range": "Период по умолчанию",
    "range1d": "1 ДЕНЬ",
    "range7d": "7 ДНЕЙ",
    "range30d": "30 ДНЕЙ",
    "rangeAll": "Все",
    "view": "Вид",
    "viewChart": "График",
    "viewTable": "Таблица",
    "thresholds": "Пороги",
    "thresholdLabel": "Название порога",
    "thresholdLabelPlaceholder": "Предупреждение 25 °C",
    "thresholdValue": "Значение",
    "thresholdKind": "Тип порога",
    "warning": "Предупр.",
    "danger": "Опасно",
    "addThreshold": "Добавить порог",
    "removeThreshold": "Удалить порог"
  },
  "tableLayer": {
    "enabledHint": "Включено — появится панель «Таблица»",
    "disabledHint": "Выключено — на странице просмотра не отображается",
    "name": "Заголовок",
    "namePlaceholder": "Таблица",
    "mode": "Тип таблицы",
    "deviceList": "Список устройств",
    "custom": "Своя таблица",
    "deviceListHint_one": "Показатели устройств чертежа выводятся автоматически · сейчас {{count}} строка.",
    "deviceListHint_few": "Показатели устройств чертежа выводятся автоматически · сейчас {{count}} строки.",
    "deviceListHint_many": "Показатели устройств чертежа выводятся автоматически · сейчас {{count}} строк.",
    "deviceListHint_other": "Показатели устройств чертежа выводятся автоматически · сейчас {{count}} строки.",
    "openConstructor": "Конструктор таблицы"
  },
  "table": {
    "title": "Конструктор таблицы",
    "fullscreen": "Во весь экран",
    "exitFullscreen": "Выйти из полноэкранного режима",
    "name": "Название таблицы",
    "namePlaceholder": "Мониторинг по створам",
    "untitled": "Таблица без названия",
    "columnsAndRows": "Столбцы и строки",
    "columns": "Столбцы (створы)",
    "columnsRange": "от {{min}} до {{max}}",
    "addColumn": "Добавить столбец",
    "removeColumn": "Убрать столбец",
    "rows": "Строки",
    "noRows": "Строк нет",
    "count": {
      "manual": "вручную {{n}}",
      "device": "устройство {{n}}",
      "formula": "формула {{n}}",
      "status": "статус {{n}}"
    },
    "addRow": "Добавить строку",
    "addRowHint": "Нажмите тип — строка добавится сразу",
    "rowType": {
      "manual": "Вручную",
      "device": "Устройство",
      "formula": "Формула",
      "status": "Статус"
    },
    "defaultRowName": "Строка {{n}}",
    "rowLimit": "Не более {{max}} строк",
    "formula": "Формула",
    "formulaPlaceholder": "Ячейка не выбрана — формула или значение",
    "usesRowFormula": "Формула строки: {{formula}}",
    "statusAuto": "Ячейка статуса вычисляется автоматически",
    "pickSensor": "Выберите показатель для ячейки",
    "grid": "Таблица",
    "size": "{{rows}} строк · {{cols}} столбцов",
    "cornerLabel": "Номер створа",
    "columnLabel": "Название столбца {{index}}",
    "editCell": "Значение ячейки",
    "emptyRows": "Чтобы добавить строку, нажмите одну из кнопок выше",
    "untitledRow": "Строка без названия",
    "formulaError": "Ошибка",
    "settings": "Настройки",
    "rowSettingsTab": "Настройки строки",
    "statusesTab": "Статусы",
    "discardTitle": "Изменения таблицы не сохранены",
    "discardText": "Если закрыть окно, изменения таблицы будут отменены.",
    "discard": "Отменить и закрыть",
    "keepEditing": "Продолжить редактирование",
    "rowSettings": {
      "none": "Строка не выбрана — нажмите заголовок строки или ячейку в таблице.",
      "name": "Название строки",
      "type": "Тип",
      "manualHint": "Введите значения в ячейки таблицы (двойной щелчок или Enter).",
      "sensors": "Показатели по столбцам",
      "sensorFor": "Показатель столбца {{column}}",
      "rowFormula": "Применить ко всем столбцам",
      "formulaHint": "R1…Rn — значения строк, C — номер столбца, X — значение устройства выше. Формула ячейки важнее.",
      "source": "Строка-источник",
      "sourceNone": "Ближайшая строка устройства",
      "sourceHint": "Статус определяется по значению этой строки.",
      "up": "Выше",
      "down": "Ниже",
      "delete": "Удалить строку"
    },
    "status": {
      "title": "Границы статусов",
      "byValue": "По значению устройства",
      "empty": "Статусы ещё не добавлены",
      "range": "Граница:",
      "rangeFrom": "выше {{value}}",
      "rangeTo": "до {{value}}",
      "rangeAll": "Все значения",
      "add": "Добавить статус",
      "autoColor": "Автоматически менять цвет ячейки",
      "edit": "{{name}} — изменить",
      "delete": "{{name}} — удалить",
      "back": "К статусам",
      "addTitle": "Новый статус",
      "editTitle": "Изменить статус",
      "new": "Новый",
      "name": "Название",
      "namePlaceholder": "Например: Важно",
      "note": "Примечание",
      "notePlaceholder": "Короткое примечание",
      "color": "Цвет",
      "colors": {
        "1ECD15": "Зелёный",
        "0275FF": "Синий",
        "F48200": "Оранжевый",
        "CA3B3D": "Красный",
        "99A3B8": "Серый"
      },
      "limits": "Граница (значение устройства)",
      "from": "от",
      "to": "до",
      "fromLabel": "Нижняя граница (от)",
      "toLabel": "Верхняя граница (до)",
      "addButton": "Добавить",
      "deleteButton": "Удалить статус",
      "deleteConfirm": "Удалить статус?",
      "deleteUsed_one": "Статус используется в {{count}} строке статуса. Всё равно удалить?",
      "deleteUsed_few": "Статус используется в {{count}} строках статуса. Всё равно удалить?",
      "deleteUsed_many": "Статус используется в {{count}} строках статуса. Всё равно удалить?",
      "deleteUsed_other": "Статус используется в {{count}} строках статуса. Всё равно удалить?",
      "errors": {
        "name": "Введите название статуса",
        "nameTaken": "Статус с таким названием уже есть",
        "number": "Граница должна быть числом",
        "order": "Значение «от» должно быть меньше «до»",
        "overlap": "Граница пересекается с другим статусом"
      }
    }
  },
  "scene": {
    "canvas": "3D-карта",
    "globeNotice": "3D-глобус (CesiumJS) пока не подключён. Модель, размещение и устройства сохраняются.",
    "needsGlobe": "доступно после подключения 3D-глобуса",
    "search": "Поиск места",
    "searchPlaceholder": "Координаты: 41.5521, 69.9654",
    "searchGo": "Перейти",
    "searchHint": "Введите координаты, например: 41.5521, 69.9654",
    "searchRange": "Неверные координаты",
    "attribution": "Карта не подключена · {{lat}}, {{lng}} · {{height}} м",
    "tools": {
      "zoomIn": "Приблизить",
      "zoomOut": "Отдалить",
      "north": "На север",
      "baseMap": "Подложка",
      "rotate": "Поворот",
      "scale": "Масштаб",
      "flyTo": "К объекту",
      "measure": "Измерение"
    },
    "emptyTitle": "3D-объект не загружен",
    "emptyText": "Загрузите 3D-модель плотины в формате GLB или glTF. Затем разместите её на карте.",
    "dropHere": "Перетащите GLB-файл сюда",
    "or": "или",
    "pickFile": "Выбрать файл",
    "formats": "Формат: .glb, .gltf (со встроенными текстурами) · макс. 100 МБ",
    "objTitle": "Конвертация OBJ пока недоступна",
    "objText": "Экспортируйте модель в GLB или glTF и загрузите её.",
    "typeError": "Этот тип файла не поддерживается",
    "sizeError": "Размер файла не более 100 МБ",
    "uploadError": "Не удалось загрузить модель",
    "uploaded": "3D-модель загружена",
    "loadError": "Не удалось загрузить 3D-сцену",
    "model": "3D-объект",
    "replace": "Заменить модель",
    "delete": "Удалить модель",
    "deleteTitle": "Удалить 3D-объект",
    "deleteText": "Модель будет удалена из сцены. Размещение и привязки устройств сохранятся.",
    "status": {
      "ready": "Готово",
      "processing": "Обработка…",
      "failed": "Не удалось прочитать файл"
    },
    "placement": "Размещение",
    "lat": "Широта",
    "lng": "Долгота",
    "height": "Высота",
    "heading": "Поворот",
    "scale": "Масштаб",
    "clamp": "Привязать к рельефу",
    "coordInvalid": "Например: 41.5521 или 41.5521° N",
    "devices": "Устройства",
    "searchDevices": "Поиск устройства",
    "pinnedDevices": "Устройства на чертежах",
    "noDevices": "На чертежах нет показателей с привязанным устройством",
    "noMatches": "Ничего не найдено",
    "dragging": "Перетаскивание…",
    "dragHint": "Перетащите устройство на 3D-объект или нажмите кнопку.",
    "needModel": "Сначала загрузите 3D-модель",
    "needModelHint": "Чтобы привязать устройства, сначала загрузите 3D-модель.",
    "attach": "Привязать к центру модели",
    "attached": "Привязано к модели",
    "attachDevice": "{{name}} — привязать к модели",
    "detachDevice": "{{name}} — отвязать от модели",
    "notPlaced": "Не привязано к модели",
    "showAnchor": "{{name}} — показать",
    "hideAnchor": "{{name}} — скрыть"
  }
}
